import { gql } from 'apollo-angular';

/**
 * Abstraction-layer TREO reference-data queries (used by the manual-input grid and the export dialogs):
 *   - SOPS: the list of SOPs (filtered to latest version client-side), used for the SOP dropdown.
 *   - TEST_PERIODS: the list of test periods (test weeks), used for the test-week dropdown.
 *   - CONFIGURATOR_USER_FUNCTIONS: the active UF → UC → SCN structure (already nested), used for
 *     the cascading UF → UC → SCN dropdowns.
 */

export const SOPS = gql`
	query sops {
		sops {
			id
			name
			version
			latestVersion
		}
	}
`;

/**
 * The SOP options for the report / configurations dialogs: the distinct numeric SOPs that appear on
 * imported main-suite documents, latest `limit` (newest last). Mirrors TREO's /api/sop — only SOPs
 * that have results, not the full SOP master list (which includes future/unused SOPs).
 */
export const SOP_OPTIONS = gql`
	query analyzerSopOptions($analyzerEnvironment: String!, $limit: Int) {
		analyzerSopOptions(analyzerEnvironment: $analyzerEnvironment, limit: $limit)
	}
`;

export const TEST_PERIODS = gql`
	query testPeriods($sortByName: Boolean) {
		testPeriods(sortByName: $sortByName) {
			id
			name
			version
			validFrom
			validTo
		}
	}
`;

/**
 * The active UF → UC → SCN structure, already nested. Used for the cascading dropdowns.
 * Replaces the legacy treoUfUcScnTree(SOP) — that query times out on the DDB cache; this is the
 * lighter, actively-used Configurator resolver, reads the same data, and takes no SOP (returns
 * all active items).
 */
export const CONFIGURATOR_USER_FUNCTIONS = gql`
	query configuratorUserFunctions {
		configuratorUserFunctions {
			Id
			Name
			UseCases {
				Id
				Name
				Scenarios {
					Id
					Name
				}
			}
		}
	}
`;
